import React from 'react';
import { string } from 'prop-types';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Translation } from 'react-i18next';

const styles = (theme) => ({
  container: {
    textAlign: 'left',
    padding: theme.spacing(4),
    borderTop: '5px solid #029E4A',
  },
  textField: {
    marginTop: theme.spacing(1),
    marginBottom: 0,
  },
  button: {
    marginTop: theme.spacing(2),
  },
  linkButton: {
    marginTop: theme.spacing(2),
  },
  subtitle2: {
    marginBottom: theme.spacing(2),
    color: '#029E4A',
    fontWeight: 700,
  },
  h2: {
    fontWeight: 400,
  },
  h6: {
    fontWeight: 700,
  },
  saveButton: {
    background: '#0280CA',
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: 'flex',
  },
});

const PrivacyPolicy = ({ title, classes, isAuthenticated }) => (
  <Translation>
    {(t) => {
      return (
        <div className={classes.container}>
          <Typography
            variant="subtitle2"
            gutterBottom
            color="inherit"
            classes={{ subtitle2: classes.subtitle2 }}
          >
            {t('polSubHeader')}
          </Typography>
          <Typography variant="h2" color="inherit" classes={{ h2: classes.h2 }}>
            {t('polHeader')}
          </Typography>
          <Typography variant="subtitle2" gutterBottom color="inherit">
            {t('polDate')}
          </Typography>
          <Typography
            variant="h6"
            gutterBottom
            color="inherit"
            classes={{ h6: classes.h6 }}
          >
            {t('polSec1Title')}
          </Typography>
          <Typography variant="body1" gutterBottom color="inherit">
            {t('polSec1Body1')}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('polSec1Body2')}
          </Typography>
          <Typography
            variant="h6"
            gutterBottom
            color="inherit"
            classes={{ h6: classes.h6 }}
          >
            {t('polSec2Title')}
          </Typography>
          <Typography variant="body1" color="inherit">
            {t('polSec2Body1')}
          </Typography>
          <Typography
            variant="body2"
            color="inherit"
            classes={{ body2: classes.h6 }}
          >
            {t('polSec2Body2')}
          </Typography>
          <Typography variant="body1" gutterBottom color="inherit">
            {t('polSec2Body3')}
          </Typography>
          <Typography
            variant="body2"
            color="inherit"
            classes={{ body2: classes.h6 }}
          >
            {t('polSec2Body4')}
          </Typography>
          <Typography variant="body1" gutterBottom color="inherit">
            {t('polSec2Body5')}
          </Typography>
          <Typography
            variant="body2"
            color="inherit"
            classes={{ body2: classes.h6 }}
          >
            {t('polSec2Body6')}
          </Typography>
          <Typography variant="body1" gutterBottom color="inherit">
            {t('polSec2Body7')}
          </Typography>
          <Typography
            variant="h6"
            gutterBottom
            color="inherit"
            classes={{ h6: classes.h6 }}
          >
            {t('polSec3Title')}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('polSec3Body1')}
          </Typography>
          <Typography variant="h6" gutterBottom classes={{ h6: classes.h6 }}>
            {t('polSec4Title')}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('polSec4Body1')}
          </Typography>
          <Typography variant="h6" gutterBottom classes={{ h6: classes.h6 }}>
            {t('polSec5Title')}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('polSec5Body1')}
          </Typography>
          <Typography variant="h6" gutterBottom classes={{ h6: classes.h6 }}>
            {t('polSec6Title')}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('polSec6Body1')}
          </Typography>
          <Typography variant="h6" gutterBottom classes={{ h6: classes.h6 }}>
            {t('polSec7Title')}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('polSec7Body1')}
          </Typography>
          <Grid item className={classes.buttonContainer}>
            <Button
              variant="contained"
              color="primary"
              className={classes.saveButton}
              component={Link}
              to={'/applications'}
            >
              {isAuthenticated ? t('backTo') : t('back')}
            </Button>
          </Grid>
        </div>
      );
    }}
  </Translation>
);
PrivacyPolicy.propTypes = {
  title: string,
};

PrivacyPolicy.defaultProps = {
  title: '',
};

export default withStyles(styles)(PrivacyPolicy);



// WEBPACK FOOTER //
// ./src/view/forms/PrivacyPolicy/PrivacyPolicy.js